<template>
    <div class="home_header">
        <div class="header_content">
            <div class="left_box">
                <div class="home_nav" v-if="$route.path === '/'">首页</div>
                <div class="back_home" v-else @click="backHome">
                    <p>返回首页</p>
                </div>
            </div>
            <div class="right_box">
                <div class="btn" @click="openSearch" v-if="!noSearchPath.includes($route.path) && !isShare">
                    <i class="iconfont icon-sousuo" style="font-size: 24px"></i>
                    <span>搜索</span>
                </div>
                <!-- <div class="btn" @click="openShare" v-if="sharehPath.includes($route.path) && !isShare && !isPreview">
                    <i class="iconfont icon-fenxiang"></i>
                    <span>分享</span>
                </div> -->
                <div class="btn" @click="toLogin" v-if="isShare">
                    <span style="letter-spacing: 0; padding-left: 0">注册/登录</span>
                </div>
                <el-dropdown size="default" @command="handleCommand" v-if="!isShare && !isPreview">
                    <div class="btn round">
                        <i class="iconfont icon-yonghu"></i>
                    </div>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item command="me">个人信息</el-dropdown-item>
                            <el-dropdown-item command="tip">
                                <div class="tip_item_box">
                                    <span>待办工作</span><span class="num" v-if="infoRTD.count">{{ infoRTD.count }}</span>
                                </div>
                            </el-dropdown-item>
                            <el-dropdown-item command="coll">收藏夹</el-dropdown-item>
                            <el-dropdown-item command="rec">收件人</el-dropdown-item>
                            <el-dropdown-item command="out">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </div>
        </div>
        <div class="search_box" id="search_box" :class="{ show: search }">
            <div class="center_box">
                <input id="search_input" placeholder="请输入搜索关键词，多个关键词空格分隔，不支持特殊符号" v-model.trim="keywords" maxlength="200" autocomplete="off" @keydown.enter="handleSearch" />
                <button @click.stop="handleSearch">搜索一下</button>
            </div>
        </div>
    </div>
    <ShareDialog :show="showS" @close="closeS" />
    <!-- 风险提示弹框 -->
    <RiskTipDialog :show="showRTD" @close="closeRTD" />
</template>

<script setup>
import { ref, computed } from "vue";
import ShareDialog from "@/components/share-dialog/week/index.vue";
import useShare from "@/components/share-dialog/week/useShare";
import { useRoute, useRouter } from "vue-router";
import { clearStorage } from "@/utils";
import { ElMessage } from "element-plus";
import outLogin from "@/utils/outLogin";
import useKeepAlive from "@/store/useKeepAlive";
import RiskTipDialog from "@/components/risk-tip-dialog/index.vue";
import useRiskTipDialog from "@/components/risk-tip-dialog/useShow";

const keepAliveStore = useKeepAlive(); // 缓存
const noSearchPath = ["/search"]; // 没有搜索按钮的页面路由
const sharehPath = ["/"]; // 有分享按钮的页面路由
const route = useRoute();
const router = useRouter();
const search = ref(false);
const keywords = ref("");
// 是否是分享
const isShare = computed(() => {
    return !!route.query.share;
});
// 是否是预览
const isPreview = computed(() => {
    return !!route.query.previewToken;
});

// 监听点击搜索框以外的元素
function onDocument(event) {
    const elem = document.getElementById("search_box");
    // 检查点击事件是否发生在elem之外
    if (!elem.contains(event.target)) {
        closeSearch();
    }
}

// 打开搜索框
function openSearch() {
    search.value = true;
    // 聚焦
    const input = document.getElementById("search_input");
    input.focus();
    // 监听整个文档的点击事件
    document.addEventListener("click", onDocument, true); // true表示在捕获阶段监听事件
}

// 关闭搜索框
function closeSearch() {
    search.value = false;
    keywords.value = "";
    document.removeEventListener("click", onDocument);
}

// 搜索一下
function handleSearch() {
    keepAliveStore.setKeepRoutes([]);
    const query = { keywords: keywords.value };
    if (!query.keywords) {
        query.noSearch = true;
    }
    router.push({
        path: "/search",
        query,
    });
}

// 分享弹框
const { show: showS, open: openS, close: closeS } = useShare();

// 点击分享
function openShare() {
    if (isPreview.value) {
        ElMessage.error("预览模式下，不能分享");
        return;
    }
    openS();
}

// 返回首页
function backHome() {
    router.replace({
        path: "/",
    });
}

// 跳转个人主页
function toMe() {
    router.push({ path: "/me" });
}

// 跳转登录
function toLogin() {
    clearStorage();
    router.replace("/login");
}

// 用户下拉菜单
function handleCommand(command) {
    switch (command) {
        case "me":
            toMe();
            break;
        case "tip":
            openRTD();
            break;
        case "coll":
            router.push({ path: "/collection" });
            break;
        case "rec":
            router.push({ path: "/recipient" });
            break;
        case "out":
            outLogin();
            break;
    }
}

// 风险提示弹框
const { show: showRTD, open: openRTD, close: closeRTD, info: infoRTD } = useRiskTipDialog({ isShare });
</script>

<style lang="scss" scoped>
.home_header {
    width: 100%;
    height: var(--home-header-height);
    background-color: #f5f5f5;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    box-shadow: 0 0 5px #ccc;
    .header_content {
        height: 100%;
        width: 1080px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left_box {
            .home_nav {
                font-size: 18px;
                color: #2e2e2e;
                user-select: none;
                position: relative;
                &::after {
                    display: block;
                    content: "";
                    border-bottom: 2px solid var(--week-primary-color);
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                }
            }
            .back_home {
                p {
                    font-size: 18px;
                    color: #2e2e2e;
                    cursor: pointer;
                    &:hover {
                        color: var(--week-primary-color);
                    }
                }
            }
        }
        .right_box {
            display: flex;
            height: 100%;
            align-items: center;
            .btn {
                height: 48px;
                width: 144px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 24px;
                border: 1px solid #cbcbcb;
                margin-left: 24px;
                cursor: pointer;
                transition: all 0.3s linear;
                .iconfont {
                    font-size: 22px;
                    color: var(--week-primary-color);
                }
                span {
                    color: #727272;
                    font-size: 18px;
                    padding-left: 17px;
                    letter-spacing: 0.6em;
                    user-select: none;
                    transition: inherit;
                }
                &:hover {
                    border-color: var(--week-primary-color);
                    background-color: var(--week-primary-color);
                    span,
                    .iconfont {
                        color: #fff;
                    }
                }
                &.round {
                    width: 48px;
                }
            }
        }
    }
    .search_box {
        background-color: #fff;
        width: 100%;
        height: 0px;
        position: absolute;
        left: 0;
        top: var(--home-header-height);
        transition: all 0.3s ease;
        overflow: hidden;
        &.show {
            height: 86px;
        }
        .center_box {
            width: 1080px;
            margin: 0 auto;
            height: 100%;
            display: flex;
            align-items: center;
            padding: 0 80px;
            justify-content: space-between;
            input {
                height: 38px;
                line-height: 38px;
                width: 85%;
                font-size: 16px;
                border: none;
                background: none;
            }
            button {
                width: 96px;
                height: 38px;
                border-radius: 2px;
                background-color: #ff5a00;
                color: #fff;
                font-size: 16px;
                transition: opacity 0.3s;
                &:hover {
                    opacity: 0.8;
                }
            }
        }
    }
}
.tip_item_box {
    display: flex;
    align-items: center;
    .num {
        background-color: var(--primary-color);
        color: #fff;
        height: 20px;
        border-radius: 10px;
        font-size: 12px;
        line-height: 12px;
        display: flex;
        align-items: center;
        padding: 0 8px;
        margin-left: 4px;
    }
}
</style>
